import Box from '@mui/material/Box';
import { Outlet } from 'infrastructure/router';
import { HEADER } from 'config';
import { useUnsavedChanges } from 'hooks';
import useOnboardingBootstrap from 'features/ecommerce/useOnboardingBootstrap';
import { HeaderOnboarding } from "./header";
import withBoostrap from './withBootstrap';
import type { DashboardProps } from './types';

const Onboarding = ({ useBootstrap = useOnboardingBootstrap }: DashboardProps) => {
    useBootstrap();
    useUnsavedChanges();

    return (
        <>
            <HeaderOnboarding />
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    pt: `${HEADER.H_MOBILE}px`,
                    width: '100%',
                    bgcolor: 'var(--onboardingBg)',
                    overflowX: 'hidden',
                    height: '100vh',
                    minHeight: 400
                }}
            >
                <Outlet />
            </Box>
        </>
    )
};

export default withBoostrap(Onboarding);
